import * as React from 'react';
import classNames from 'classnames';
import { Table } from 'antd';
import { Fragment, ScrollCustomStyles } from 'components';
import { TableProps as AntTableProps } from 'antd/lib/table/interface';
import { ColumnProps as AntColumnProps } from 'antd/lib/table';
import { isEmpty } from 'lodash-es';
import styles from './Table.module.scss';
import { TABLE_SIZE_CONFIG } from 'app-constants';
export interface TableProps<T = any> extends AntTableProps<T> {
	activeSizeItem?: number;
	onPageSizeChange?: (item: number) => void;
}
export interface ColumnProps<T> extends AntColumnProps<T> {}

const TableCustom: React.FC<TableProps> = (props: TableProps) => (
	<Fragment>
		<ScrollCustomStyles>
			<Table {...props} className={classNames(styles.table, props.className)} />
		</ScrollCustomStyles>

		{!isEmpty(props.pagination) && (
			<div className={styles.paginationPageSize}>
				Show Rows:
				<span>
					{TABLE_SIZE_CONFIG.map(item => (
						<span
							key={`tablePagination-${item}`}
							className={classNames({
								paginationPageSizeItem: true,
								paginationPageSizeItemActive: item === props.activeSizeItem,
							})}
							onClick={() => props.onPageSizeChange && props.onPageSizeChange(item)}
						>
							{item}
						</span>
					))}
				</span>
			</div>
		)}
	</Fragment>
);

export default TableCustom;
